/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Images
 */
import { LockIcon } from '../../../../images/icons/Lock/Lock'

export default class UserAccountPicture extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            actionChangePassword: props.actionChangePassword,
            actionChangePicture: props.actionChangePicture,
        }
    }

    render() {
        return (
            <div className="user__account">
                <h4>User details</h4>

                <div className="user__account__details detail">
                    <div className="detail__photo">
                        <div className="detail__photo--svg">
                            <LockIcon />
                        </div>
                        <div className="detail__text">
                            <div>
                                <div
                                    className="detail__text--title"
                                >Change Password
                                </div>
                                <div
                                    className="detail__text--button"
                                    onClick={this.state.actionChangePassword}
                                >CHANGE
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="user__account__details detail">
                    <div className="detail__photo">
                        <div className="detail__photo__container">
                            <img
                                src={this.props.avatar}
                                alt="Profile photo"
                            />
                        </div>
                        <div className="detail__text">
                            <div>
                                <div
                                    className="detail__text--title"
                                >Profile Picture
                                </div>
                                <div
                                    className="detail__text--button"
                                    onClick={this.state.actionChangePicture}
                                >CHANGE
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/UserAccount/components/UserAccountPicture.tsx